// extracted by mini-css-extract-plugin
export default {"subtitle":"your-birthplace_subtitle__PxB5Y","image":"your-birthplace_image__i79sD"};